import {
  Container,
  Header,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { GroupedMerchantAddress } from "../../../features/api-interfaces";
import { LABELS } from "../constants";
import { changeStyle } from "../../../utils/format";
import { formatAddress, getContractRouteStr } from "../util";
import { AddressRow } from "./AddressRow";
import { COMMON_LABELS } from "../../default-constants";

interface IAddressInfo {
  title: string;
  addressInfo: GroupedMerchantAddress;
}

/**
 * 申請事業者住所モーダル 住所情報
 */
export const AddressInfoContent = (props: IAddressInfo) => {
  const { title, addressInfo } = props;
  const postalCode = changeStyle(addressInfo.postalCode);
  const address = formatAddress(addressInfo.address1, addressInfo.address2);
  const contractRoutesStr = getContractRouteStr(addressInfo.contractRoutes);

  return (
    <Container header={<Header variant={"h2"}>{title}</Header>}>
      <SpaceBetween direction={"vertical"} size={"xxs"}>
        <AddressRow
          label={LABELS.ADDRESS}
          value={postalCode + COMMON_LABELS.FULL_WIDTH_SPACE + address}
        />
        <AddressRow label={LABELS.CONTRACT_ROUTE} value={contractRoutesStr} />
      </SpaceBetween>
    </Container>
  );
};
